import { render, staticRenderFns } from "./LoginDetail.vue?vue&type=template&id=6172fe62&scoped=true&"
import script from "./LoginDetail.vue?vue&type=script&lang=js&"
export * from "./LoginDetail.vue?vue&type=script&lang=js&"
import style0 from "./LoginDetail.vue?vue&type=style&index=0&id=6172fe62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6172fe62",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VRow})
